import { css } from "@emotion/react";

export const PromotionCardStyle = {
  self: css`
    width: 100%;
  `,

  thumbnail: css`
    border-radius: inherit;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      /* object-fit: cover; */
      border-radius: inherit;
      aspect-ratio: 2/1;
    }
  `,
};
